if (!customElements.get('prelander-banner')) {
  customElements.define(
    'prelander-banner',
    class PrelanderBanner extends HTMLElement {
      constructor() {
        super();
        this.scrollToButton = this.querySelector('[data-scroll-to-button]')
        this.scrollToButton.addEventListener('click', this.scrollToAnchor.bind(this));
        this.handleAdsId()
        this.checkAdsIdInUrl();
      }

      scrollToAnchor(evt) {
        const sectionId = this.getAttribute('data-scroll-to');

        if (sectionId != '') {
          const target = document.querySelector(`${sectionId}`);
          const targetPosition = (target.getBoundingClientRect().top + window.pageYOffset) - 150;
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      }

      handleAdsId() {
        let adsId = this.getAttribute('data-ads-id')
        
        if (adsId) {
          this.adsIdArray = adsId.split(',').map(id => Number(id.trim()));
        } 
      }

      checkAdsIdInUrl() {
        const url = window.location.href;
        if (this.adsIdArray) {
          const urlId = this.adsIdArray.find(id => url.includes(id.toString()));
          if (urlId) {
            this.classList.remove('hero-banner__hide')
          } else {
            console.log('No matching adsId found in the URL');
          }
        }
      }
    }
  );
}